import Wealth1 from './assets/wealth_1.svg'
import Wealth2 from './assets/wealth_2.svg'
import Wealth3 from './assets/wealth_3.svg'
import Support from './assets/support.svg'
import AvatarGroup from './assets/avatar_group.svg'
import Avatar from './assets/avatar.svg'
import Stocks from './assets/stocks.svg'

export const CHIPS = ['managed', 'diy', 'savings']

export type Chip = (typeof CHIPS)[number]

export type CardId =
  | 'managed_1'
  | 'managed_2'
  | 'managed_3'
  | 'diy_1'
  | 'savings_1'

export const ChipCards: {
  id: Chip
  cards: { id: CardId; img?: string; contactImg?: string }[]
}[] = [
  {
    id: CHIPS[0],
    cards: [
      { id: 'managed_1', img: Wealth1, contactImg: Support },
      { id: 'managed_2', img: Wealth2, contactImg: AvatarGroup },
      { id: 'managed_3', img: Wealth3, contactImg: Avatar },
    ],
  },
  { id: CHIPS[1], cards: [{ id: 'diy_1', contactImg: Stocks }] },
  { id: CHIPS[2], cards: [{ id: 'savings_1', contactImg: Support }] },
]

export const XO_FEES = [
  'order-fees',
  'bond-trade-fees',
  'currency-conversion-fees',
] as const

export const categories =
  process.env.GATSBY_COUNTRY === 'GB'
    ? (['active', 'fixed', 'liquidity-plus'] as const)
    : (['active', 'liquidity-plus'] as const)

export const activeBrackets =
  process.env.GATSBY_COUNTRY !== 'GB'
    ? [
        { label: '0', fee: '0.50%' },
        { label: '101', fee: '0.40%' },
        { label: '501', fee: '0.30%' },
      ]
    : [
        { label: 'Up to £50k', fee: '0.45%' },
        { label: 'From £50k to £100k', fee: '0.20%' },
        { label: 'From £100k to £1.5 million ', fee: '0.10%' },
        { label: 'Above £1.5 million', fee: 'No fees' },
      ]

export const fixedBrackets = [{ label: 'All investments', fee: '0.15%' }]

export const liquidityPlusBrackets = [
  { label: 'All investments', fee: '0.05%' },
]

export const custodyOrPlatformFee = {
  label:
    process.env.GATSBY_COUNTRY === 'GB'
      ? 'All managed portfolios (Min £1.25/month)'
      : 'todo it',
  fee: process.env.GATSBY_COUNTRY === 'GB' ? '0.25%' : 'todo it',
}
